import script from "./image.vue?vue&type=script&lang=ts&setup=true"
export * from "./image.vue?vue&type=script&lang=ts&setup=true"

import "./image.vue?vue&type=style&index=0&id=fe89fc2c&lang=scss"

const __exports__ = script;

export default __exports__